import { Datasets, LCTOnlyDatasets } from "../../../constants/enums"
import { TConfirmSetUpMode } from "../hooks/account/useConfirmSetUp"
/* eslint-disable import/first */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

const PRIVATE_BASE = CONFIG.PRIVATE_API_URL

const ADMIN_V1 = "/admin/v1"
const TTR_V1 = "/ttr/v1"
const LCT_V1 = "/lct/v1"
const REPORTING_V1 = "/reporting/v1"
const ORGS_V1 = "/orgs/v1"
const DNO_ASSIGNMENT_V1 = "/dno-assignment/v1"

const LIST_USERS_BASE = `${PRIVATE_BASE}${ADMIN_V1}/list-identifier-group`
const ADD_GROUP = `${PRIVATE_BASE}${ADMIN_V1}/add-to-group`
const REMOVE_GROUP = `${PRIVATE_BASE}${ADMIN_V1}/remove-from-group`
const DELETE = `${PRIVATE_BASE}${ADMIN_V1}/delete-user`
const LIST_IDENTIFIER_BASE = `${PRIVATE_BASE}${ADMIN_V1}/list-all-identifier-groups`
const GET_DEVICE_REFERENCE_BASE = `${PRIVATE_BASE}${TTR_V1}/get-device-reference`
const PUBLISH_DEVICE_BASE = `${PRIVATE_BASE}${TTR_V1}/publish-device`
const PUBLISH_AMENDMENT_BASE = `${PRIVATE_BASE}${TTR_V1}/publish-amendment`
const LIST_TTR_ATTACHMENT_SUMMARIES_BASE = `${PRIVATE_BASE}${TTR_V1}/list-attachment-summaries`
const LIST_LCT_ATTACHMENT_SUMMARIES_BASE = `${PRIVATE_BASE}${LCT_V1}/list-attachment-summaries`
const LIST_TTR_ATTACHMENT_SUMMARIES_PUBLIC_BASE = `${PRIVATE_BASE}${TTR_V1}/list-attachment-summaries-public`
const LIST_LCT_ATTACHMENT_SUMMARIES_PUBLIC_BASE = `${PRIVATE_BASE}${LCT_V1}/list-attachment-summaries-public`
const DELETE_TTR_ATTACHMENT_BASE = `${PRIVATE_BASE}${TTR_V1}/delete-attachment`
const DELETE_LCT_ATTACHMENT_BASE = `${PRIVATE_BASE}${LCT_V1}/delete-attachment`
const USER_SUGGESTION = `${PRIVATE_BASE}${DNO_ASSIGNMENT_V1}/suggest-users`
const USER_BY_ID = `${PRIVATE_BASE}${DNO_ASSIGNMENT_V1}/user`
const POST_USER = `${PRIVATE_BASE}${DNO_ASSIGNMENT_V1}/assign-application`
const UPDATE_QUICKSIGHT = `${PRIVATE_BASE}${ADMIN_V1}/update-quicksight-access`
const DELETE_QUICKSIGHT = `${PRIVATE_BASE}${ADMIN_V1}/delete-quicksight-user`
const RESET_MFA = `${PRIVATE_BASE}${ADMIN_V1}/reset-user-mfa`
const RESTORE_PERMISSIONS = `${PRIVATE_BASE}${ADMIN_V1}/restore-permissions-after-mfa`

const RESTORE_USER_PERMISSIONS_AFTER_MFA = (): string =>
    `${RESTORE_PERMISSIONS}`

const RESET_USER_MFA = (userName: string): string =>
    `${RESET_MFA}?user_name=${userName}`

const DELETE_QUICKSIGHT_USER = (userName: string): string =>
    `${DELETE_QUICKSIGHT}?user_name=${userName}`

const UPDATE_QUICKSIGHT_ACCESS = (userName: string, userRole: string): string =>
    `${UPDATE_QUICKSIGHT}?user_name=${userName}&user_role=${userRole}`

const ADD_TO_GROUP = (userName: string, group: string): string =>
    `${ADD_GROUP}?group=${group}&user_name=${userName}`

const REMOVE_FROM_GROUP = (userName: string, group: string): string =>
    `${REMOVE_GROUP}?group=${group}&user_name=${userName}`

const DELETE_USER = (userName: string): string =>
    `${DELETE}?user_name=${userName}`

const LIST_USERS_TO_MANAGE = (approved: boolean): string =>
    `${LIST_USERS_BASE}?approved=${approved ? "true" : "false"}`

const LIST_USERS_SYS_ADMIN = (
    approved: boolean,
    value: string | null
): string =>
    `${LIST_USERS_BASE}?approved=${
        approved ? "true" : "false"
    }&identifier_group=${value}`

const LIST_IDENTIFIER_GROUPS = (): string => `${LIST_IDENTIFIER_BASE}`

const LIST_USER_SUGGESTIONS = (searchTerm?: string): string =>
    `${USER_SUGGESTION}${searchTerm ? `?search_term=${searchTerm}` : ""}`

const GET_USER_BY_ID = (userId: string): string =>
    `${USER_BY_ID}?user_id=${userId}`

const POST_USER_ASSIGNMENT = (userId: string, applicationId: string): string =>
    `${POST_USER}?user_id=${userId}&application_id=${applicationId}`

const GET_DEVICE_REFERENCE = (manufacturerId?: number | null): string =>
    manufacturerId
        ? `${GET_DEVICE_REFERENCE_BASE}?manufacturer_id=${manufacturerId}`
        : `${GET_DEVICE_REFERENCE_BASE}`

const PUBLISH_DEVICE = `${PUBLISH_DEVICE_BASE}`

const TTR_ASSESS_DEVICE = `${PRIVATE_BASE}${TTR_V1}/submit-assessment`

const TTR_RAISE_ALERT = `${PRIVATE_BASE}${TTR_V1}/raise-alert`
const TTR_DELETE_ALERT = (deviceSystemRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/delete-alert?deviceSystemRef=${deviceSystemRef}`

const LCT_RAISE_ALERT = (dataset: string): string =>
    `${PRIVATE_BASE}${LCT_V1}/raise-alert?dataset=${dataset}`
const LCT_DELETE_ALERT = (deviceSystemRef: string, dataset: string): string =>
    `${PRIVATE_BASE}${LCT_V1}/delete-alert?deviceSystemRef=${deviceSystemRef}&dataset=${dataset}`

const DELETE_GEN_DEVICE = (deviceSystemRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/delete-device?device_ref=${deviceSystemRef}`
const DELETE_LCT_DEVICE = (
    deviceSystemRef: string,
    dataset: Datasets
): string =>
    `${PRIVATE_BASE}${LCT_V1}/delete-device?device_ref=${deviceSystemRef}&dataset=${dataset}`

const TTR_CREATE_COMMENT = `${PRIVATE_BASE}${TTR_V1}/publish-comment`

const LCT_CREATE_COMMENT = (dataset: string): string =>
    `${PRIVATE_BASE}${LCT_V1}/publish-comment?dataset=${dataset}`

const TTR_DELETE_COMMENT = (
    deviceSystemRef: string,
    commentId: string
): string =>
    `${PRIVATE_BASE}${TTR_V1}/delete-comment?deviceSystemRef=${deviceSystemRef}&commentId=${commentId}`

const LCT_DELETE_COMMENT = (
    deviceSystemRef: string,
    commentId: string,
    dataset: string
): string =>
    `${PRIVATE_BASE}${LCT_V1}/delete-comment?dataset=${dataset}&deviceSystemRef=${deviceSystemRef}&commentId=${commentId}`

const TTR_PIN_COMMENT = (deviceSystemRef: string, commentId: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/pin-comment?deviceSystemRef=${deviceSystemRef}&commentId=${commentId}`

const LCT_PIN_COMMENT = (
    deviceSystemRef: string,
    commentId: string,
    dataset: string
): string =>
    `${PRIVATE_BASE}${LCT_V1}/pin-comment?dataset=${dataset}&deviceSystemRef=${deviceSystemRef}&commentId=${commentId}`

const TTR_UNPIN_COMMENT = (deviceSystemRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/unpin-comment?deviceSystemRef=${deviceSystemRef}`

const LCT_UNPIN_COMMENT = (deviceSystemRef: string, dataset: string): string =>
    `${PRIVATE_BASE}${LCT_V1}/unpin-comment?deviceSystemRef=${deviceSystemRef}&dataset=${dataset}`

const LCT_ASSESS_DEVICE = `${PRIVATE_BASE}${LCT_V1}/submit-assessment`

const GET_TTR_ATTACHMENT_UPLOAD_URLS = `${PRIVATE_BASE}${TTR_V1}/get-attachment-upload-urls`

const GET_LCT_ATTACHMENT_UPLOAD_URLS = (isAmendment: boolean): string =>
    `${PRIVATE_BASE}${LCT_V1}/get-attachment-upload-urls?isAmendment=${isAmendment}`

const GET_ATTACHMENT_DOWNLOAD_URL = (dataset: Datasets): string =>
    `${PRIVATE_BASE}${
        dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT
            ? TTR_V1
            : LCT_V1
    }/get-attachment-download-url${
        dataset !== Datasets.TTR && dataset !== Datasets.TTR_DRAFT
            ? `?deviceType=${dataset}`
            : ""
    }`
const GET_ATTACHMENT_DOWNLOAD_URL_PUBLIC = (dataset: Datasets): string =>
    `${PRIVATE_BASE}${
        dataset === Datasets.TTR ? TTR_V1 : LCT_V1
    }/get-attachment-download-url-public${
        dataset !== Datasets.TTR && dataset !== Datasets.TTR_DRAFT
            ? `?deviceType=${dataset}`
            : ""
    }`

const START_NEW_VERSION = (deviceRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/start-new-version?device_ref=${deviceRef}`

const START_NEW_AMENDMENT = (deviceRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/start-new-amendment?device_ref=${deviceRef}`

const PUBLISH_AMENDMENT = `${PUBLISH_AMENDMENT_BASE}`

/**
 * Returns the url to list attachment summaries
 * @param deviceRef - device ref
 * @param attachmentUuid - only used for amendments - undefined otherwise
 * @returns url
 */
const LIST_ATTACHMENT_SUMMARIES = (
    dataset: Datasets,
    deviceRef?: string,
    attachmentUuid?: string,
    isSignedIn?: boolean,
    isLctAmendment?: boolean
): string => {
    const isTtr = dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT
    const isLctAmendFlag = isTtr ? false : isLctAmendment
    const baseUrl =
        dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT
            ? LIST_TTR_ATTACHMENT_SUMMARIES_BASE
            : LIST_LCT_ATTACHMENT_SUMMARIES_BASE
    const publicUrl =
        dataset === Datasets.TTR || dataset === Datasets.TTR_DRAFT
            ? LIST_TTR_ATTACHMENT_SUMMARIES_PUBLIC_BASE
            : LIST_LCT_ATTACHMENT_SUMMARIES_PUBLIC_BASE
    const deviceRefParam = deviceRef ? `deviceRef=${deviceRef}` : ""
    const attachmentUuidParam = attachmentUuid
        ? `attachmentUUID=${attachmentUuid}`
        : ""
    const isAmendParam = isLctAmendFlag ? `isAmendment=${isLctAmendFlag}` : ""
    let queryParams = [deviceRefParam, attachmentUuidParam, isAmendParam]
        .filter(Boolean)
        .join("&")
    if (!isTtr) {
        queryParams = `${queryParams}&deviceType=${dataset}`
    }
    return `${isSignedIn ? baseUrl : publicUrl}?${queryParams}`
}

const PUBLISH_TTR_ATTACHMENT = `${PRIVATE_BASE}${TTR_V1}/publish-attachment`
const PUBLISH_LCT_ATTACHMENT = (
    lctDataset: Datasets,
    isAmendment = false
): string =>
    `${PRIVATE_BASE}${LCT_V1}/publish-attachment?deviceType=${lctDataset}${
        isAmendment ? `&isAmendment=${isAmendment}` : ""
    }`
const UNPUBLISH_TTR_ATTACHMENT = `${PRIVATE_BASE}${TTR_V1}/unpublish-attachment`
const UNPUBLISH_LCT_ATTACHMENT = (
    lctDataset: Datasets,
    isAmendment = false
): string =>
    `${PRIVATE_BASE}${LCT_V1}/unpublish-attachment?deviceType=${lctDataset}${
        isAmendment ? `&isAmendment=${isAmendment}` : ""
    }`

/**
 * Returns the url to delete a TTR attachment
 * @param deviceRef - device ref
 * @param fileName - file name
 * @param attachmentUuid - only used for amendments - undefined otherwise
 * @returns url
 */
const DELETE_TTR_ATTACHMENT = (
    deviceRef: string,
    fileName: string,
    attachmentUuid?: string
): string =>
    `${DELETE_TTR_ATTACHMENT_BASE}?file_name=${fileName}&device_ref=${deviceRef}${
        attachmentUuid ? `&attachment_uuid=${attachmentUuid}` : ""
    }`

/**
 * Returns the url to delete a LCT attachment
 * @param fileName - file name
 * @param attachmentUuid - only used for amendments - undefined otherwise
 * @param deviceType - device type
 * @param isAmendment - is amendment
 * @returns url
 */
const DELETE_LCT_ATTACHMENT = (
    fileName: string,
    deviceType: Datasets,
    attachmentUuid: string,
    isAmendment = false
): string =>
    `${DELETE_LCT_ATTACHMENT_BASE}?file_name=${fileName}&deviceType=${deviceType}&attachmentUUID=${attachmentUuid}&isAmendment=${isAmendment}`

const CONTINUE_DEVICE_DRAFT = (deviceRef: string): string =>
    `${PRIVATE_BASE}${TTR_V1}/continue-draft?device_ref=${deviceRef}`

const SAVE_DEVICE_DRAFT = `${PRIVATE_BASE}${TTR_V1}/save-draft`

const PUBLISH_LCT_DEVICE = `${PRIVATE_BASE}${LCT_V1}/publish-device`

const PUBLISH_LCT_AMENDMENT = `${PRIVATE_BASE}${LCT_V1}/publish-amendment`

const START_NEW_LCT_DEVICE_AMENDMENT = (
    deviceRef: string,
    attachmentUUID: string,
    dataset: LCTOnlyDatasets
): string =>
    `${PRIVATE_BASE}${LCT_V1}/start-new-amendment?deviceRef=${deviceRef}&attachmentUUID=${attachmentUUID}&dataset=${dataset}`

const START_NEW_LCT_DEVICE_VERSION = (
    deviceRef: string,
    attachmentUUID: string,
    dataset: LCTOnlyDatasets
): string =>
    `${PRIVATE_BASE}${LCT_V1}/start-new-version?deviceRef=${deviceRef}&attachmentUUID=${attachmentUUID}&dataset=${dataset}`

const REPORTING = `${PRIVATE_BASE}${REPORTING_V1}`
const MANU_REPORTING = `${REPORTING}/manufacturer`
const DNO_REPORTING = `${REPORTING}/dno`
const ASSESSOR_GEN_REPORTING = `${REPORTING}/assessor-gen`
const ASSESSOR_DEM_REPORTING = `${REPORTING}/assessor-demand`
const ENA_SYS_ADMIN_REPORTING = `${REPORTING}/sys-admin`
const INSTALLER_FEEDBACK = `${REPORTING}/installer-feedback`

// Insights
const INSIGHTS_V1 = `${PRIVATE_BASE}/insights/v1`
export const INSIGHTS_EMBEDDED_URL = `${INSIGHTS_V1}/embedded-url`

const SAVE_LCT_DEVICE_DRAFT = `${PRIVATE_BASE}${LCT_V1}/save-draft`

const CONTINUE_LCT_DEVICE_DRAFT = (
    deviceRef: string,
    dataset: LCTOnlyDatasets
): string =>
    `${PRIVATE_BASE}${LCT_V1}/continue-draft?systemReference=${deviceRef}&dataset=${dataset}`

// Organisation
const CREATE_ORG = `${PRIVATE_BASE}${ORGS_V1}/create-organisation`
const GET_MY_ORG = `${PRIVATE_BASE}${ORGS_V1}/get-organisation`
const INVITE_USER = `${PRIVATE_BASE}${ORGS_V1}/invite-user`
const PENDING_INVITE = `${PRIVATE_BASE}${ORGS_V1}/pending-invite`
const ACCEPT_INVITE = `${PRIVATE_BASE}${ORGS_V1}/accept-invite`
const REJECT_INVITE = `${PRIVATE_BASE}${ORGS_V1}/reject-invite`
const IS_DOMAIN_CLAIMABLE = `${PRIVATE_BASE}${ORGS_V1}/is-domain-claimable`
const CONFIRM_SET_UP = (mode: TConfirmSetUpMode): string =>
    `${PRIVATE_BASE}${ORGS_V1}/confirm-set-up?mode=${mode}`

// comment toggle
const LCT_DEVICE_READ_COMMENTS = (
    deviceSysRef: string,
    dataset: Datasets
): string =>
    `${PRIVATE_BASE}${LCT_V1}/thread-read-state?deviceSystemRef=${deviceSysRef}&dataset=${dataset}`

const TTR_DEVICE_READ_COMMENTS = (
    deviceSysRef: string,
    dataset: Datasets
): string =>
    `${PRIVATE_BASE}${TTR_V1}/thread-read-state?deviceSystemRef=${deviceSysRef}&dataset=${dataset}`

export {
    ACCEPT_INVITE as ACCPETING_INVITE,
    ADD_TO_GROUP,
    CONFIRM_SET_UP,
    CONTINUE_DEVICE_DRAFT,
    CREATE_ORG,
    DELETE_TTR_ATTACHMENT,
    DELETE_LCT_ATTACHMENT,
    DELETE_LCT_DEVICE,
    DELETE_GEN_DEVICE,
    DELETE_USER,
    GET_TTR_ATTACHMENT_UPLOAD_URLS,
    GET_LCT_ATTACHMENT_UPLOAD_URLS,
    GET_ATTACHMENT_DOWNLOAD_URL,
    GET_ATTACHMENT_DOWNLOAD_URL_PUBLIC,
    GET_DEVICE_REFERENCE,
    GET_MY_ORG,
    INVITE_USER,
    LCT_ASSESS_DEVICE,
    LCT_CREATE_COMMENT,
    LCT_DELETE_ALERT,
    LCT_DELETE_COMMENT,
    LCT_PIN_COMMENT,
    LCT_RAISE_ALERT,
    LCT_UNPIN_COMMENT,
    LIST_ATTACHMENT_SUMMARIES,
    LIST_IDENTIFIER_GROUPS,
    LIST_USERS_SYS_ADMIN,
    LIST_USERS_TO_MANAGE,
    LIST_USER_SUGGESTIONS,
    GET_USER_BY_ID,
    IS_DOMAIN_CLAIMABLE,
    PENDING_INVITE,
    POST_USER_ASSIGNMENT,
    PUBLISH_AMENDMENT,
    PUBLISH_LCT_ATTACHMENT,
    PUBLISH_TTR_ATTACHMENT,
    PUBLISH_DEVICE,
    PUBLISH_LCT_DEVICE,
    REMOVE_FROM_GROUP,
    REJECT_INVITE,
    SAVE_DEVICE_DRAFT,
    START_NEW_AMENDMENT,
    START_NEW_VERSION,
    TTR_ASSESS_DEVICE,
    TTR_CREATE_COMMENT,
    TTR_DELETE_ALERT,
    TTR_DELETE_COMMENT,
    TTR_PIN_COMMENT,
    TTR_RAISE_ALERT,
    TTR_UNPIN_COMMENT,
    UNPUBLISH_LCT_ATTACHMENT,
    UNPUBLISH_TTR_ATTACHMENT,
    PUBLISH_LCT_AMENDMENT,
    START_NEW_LCT_DEVICE_AMENDMENT,
    START_NEW_LCT_DEVICE_VERSION,
    MANU_REPORTING,
    DNO_REPORTING,
    ASSESSOR_GEN_REPORTING,
    ASSESSOR_DEM_REPORTING,
    ENA_SYS_ADMIN_REPORTING,
    INSTALLER_FEEDBACK,
    SAVE_LCT_DEVICE_DRAFT,
    CONTINUE_LCT_DEVICE_DRAFT,
    UPDATE_QUICKSIGHT_ACCESS,
    DELETE_QUICKSIGHT_USER,
    RESET_USER_MFA,
    RESTORE_USER_PERMISSIONS_AFTER_MFA,
    LCT_DEVICE_READ_COMMENTS,
    TTR_DEVICE_READ_COMMENTS,
}
